export const generateCreationLabel = (customText) => (textToPrependTo) => `${customText}: "${textToPrependTo}"`;